const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;

export const normalizeShopByPathname = (
  url: string | null | undefined,
): string | null => {
  if (!url) return null;

  try {
    const path = ABSOLUTE_URL_PATTERN.test(url)
      ? new URL(url).pathname
      : url.split("?")[0]?.split("#")[0];

    if (!path) return null;

    const trimmed = path.replace(/\/+$/, "");
    return trimmed || "/";
  } catch {
    return null;
  }
};

const shopByPathMatches = (itemPath: string, pathname: string): boolean => {
  if (itemPath === "/") return pathname === "/";
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
};

export const isActiveShopByHref = (
  itemUrl: string | null | undefined,
  pathname: string | null | undefined,
  allItemUrls: Array<string | null | undefined>,
): boolean => {
  const itemPath = normalizeShopByPathname(itemUrl);
  const currentPath = normalizeShopByPathname(pathname);
  if (!itemPath || !currentPath) return false;

  let bestMatch: string | null = null;
  for (const candidateUrl of allItemUrls) {
    const candidate = normalizeShopByPathname(candidateUrl);
    if (!candidate || !shopByPathMatches(candidate, currentPath)) continue;
    if (!bestMatch || candidate.length > bestMatch.length) {
      bestMatch = candidate;
    }
  }

  return itemPath === bestMatch;
};
